<template>
  <div class="br-pagebody pd-x-20 pd-sm-x-30">
    <div class="card bd-gray-400">
      <table class="table mg-b-0 table-contact bill data-table">
        <thead>
          <tr>
            <th>{{ $t("order.退换单编号") }}</th>
            <th>{{ $t("order.供应商信息") }}</th>
            <th>{{ $t("order.退换商品信息") }}</th>
            <th>{{ $t("order.退换单类型") }}</th>
            <th>{{ $t("order.货款 / 运费 / 实际应退总额") }}</th>
            <th>{{ $t("order.备注") }}</th>
            <th>{{ $t("order.时间") }}</th>
            <th>{{ $t("order.操作") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in items" :key="item.id">
            <td>
              <div class="tx-white">
                {{ item.code }}
              </div>
              <div>
                {{ $t("order.采购单：")
                }}<span class="tx-white">{{
                  item.orderCode ? item.orderCode : "---"
                }}</span>
              </div>
              <div>
                {{ $t("order.ERP单号")}}:
                <span class="tx-white mg-r-5">
                  {{item.codeErp || "---"}}
                </span>
              </div>
              <div>
                {{ $t("order.状态：")
                }}<span :class="item.status | statusClass">{{
                  $t(showStatu(item.status))
                }}</span>
              </div>
            </td>
            <td>
              <div>
                {{ $t("order.客户：")
                }}<span
                  class="d-inline-block tx-white tx-ellipsis1"
                  style="max-width: 200px"
                  >{{ item.distributorName }}</span
                >
              </div>
              <div>
                {{ $t("order.联系人：") }}
                <span class="tx-white">{{ item.distributorContact }}</span>
              </div>
              <div v-if="item.distributorMobile">
                {{ $t("order.电话：")
                }}<span class="tx-white">{{ item.distributorMobile }}</span>
              </div>
              <div v-if="item.distributorQQ">
                QQ：<span class="tx-white">{{ item.distributorQQ }}</span>
              </div>
            </td>
            <td>
              <template v-for="(pro, proI) in item.items.slice(0,3)">
                <div class="d-flex" v-if="proI < 4 || item.showAllProducts" :key="pro.id">
                  <el-tooltip class="item" effect="dark" :content="pro.name" placement="right">
                     <div class="single">{{ pro.name }}</div>
                  </el-tooltip>
                  <span class="tx-white"> × {{ pro.quantity }}</span>
                </div>
              </template>
              <el-button
                v-if="item.items && item.items.length"
                class="details"
                type="text"
                @click="returnGoodsDetails(item)"
                >{{ $t("order.详情") }}</el-button
              >
              <div v-if="item.items.length > 4 && !item.showAllProducts">
                {{ $t("order.等共") }}
                <span class="tx-white">{{ item.items.length }}</span>
                {{ $t("order.种") }}
                <a
                  class="tx-info"
                  href="javascript:;"
                  @click="showAllProducts(item)"
                  >{{ $t("order.查看全部") }}</a
                >
              </div>
            </td>
            <td>
              <div class="tx-white">
                {{ $t(returnType[item.type]) }}
              </div>
            </td>
            <td>
              <div v-if="item.type != 3">
                {{ $t("order.货款：")
                }}<span class="tx-white">￥{{ item.itemAmount }}</span>
              </div>
              <div v-if="item.type != 3">
                {{ $t("order.运费：") }}
                <span
                  v-if="/1|2|3/.test(item.status) && item.shippingType == 2"
                  class="tx-white"
                  >{{ $t("order.尚未填写") }}</span
                >
                <span v-else class="tx-white">￥{{ item.shippingAmount }}</span>
              </div>
              <div
                v-if="
                  item.trackInfoJson &&
                  item.trackInfoJson.length &&
                  item.type == 3
                "
              >
                <div
                  v-for="tackInfo in item.trackInfoJson"
                  :key="tackInfo.expressCode"
                >
                  {{ $t("order.运费：")
                  }}<span class="tx-white"
                    >￥{{ tackInfo.shippingAmount }}</span
                  >
                </div>
              </div>
              <div v-if="item.type != 3">
                {{ $t("order.实际应退：")
                }}<span class="tx-white">￥{{ item.totalAmount }}</span>
              </div>
              <div
                v-if="
                  item.trackInfoJson &&
                  item.trackInfoJson.length &&
                  item.type != 3
                "
              >
                <span class="tx-white">
                  {{ item.trackInfoJson[0].companyName }}:
                  <a
                    v-if="
                      item.trackInfoJson[0].trackInfo &&
                      !item.trackInfoJson[0].trackInfo.length
                    "
                    class="mg-l-5 tx-info"
                    href="javascript:;"
                    @click="showExpress(item.trackInfoJson[0])"
                  >
                    {{ item.trackInfoJson[0].expressCode }}
                  </a>
                  <a
                    v-if="
                      item.trackInfoJson[0].trackInfo &&
                      item.trackInfoJson[0].trackInfo.length
                    "
                    class="mg-l-5 tx-info"
                    href="javascript:;"
                    @click="showExpressLog(item.trackInfoJson[0])"
                  >
                    {{ item.trackInfoJson[0].expressCode }}
                  </a>
                </span>
              </div>
              <div
                v-if="
                  item.trackInfoJson &&
                  item.trackInfoJson.length &&
                  item.type == 3
                "
              >
                <div
                  v-for="tackInfo in item.trackInfoJson"
                  :key="tackInfo.expressCode"
                >
                  <span class="tx-white">
                    {{ tackInfo.companyName }}:
                    <a
                      v-if="
                        item.trackInfoJson[0].trackInfo &&
                        !item.trackInfoJson[0].trackInfo.length
                      "
                      class="mg-l-5 tx-info"
                      href="javascript:;"
                      @click="showExpress(item.trackInfoJson[0])"
                    >
                      {{ tackInfo.expressCode }}
                    </a>
                    <a
                      v-if="
                        item.trackInfoJson[0].trackInfo &&
                        item.trackInfoJson[0].trackInfo.length
                      "
                      class="mg-l-5 tx-info"
                      href="javascript:;"
                      @click="showExpressLog(item.trackInfoJson[0])"
                    >
                      {{ tackInfo.expressCode }}
                    </a>
                  </span>
                </div>
              </div>
            </td>
            <td>
              <a
                v-if="item.remark && item.remark.length"
                class="pd-5 tx-info"
                href="javascript:;"
                data-container="body"
                data-toggle="tooltip-primary"
                data-placement="top"
                data-html="true"
                :data-original-title="remarkFormat(item.remark)"
              >
                <i class="icon ion-chatbox-working tx-20 tx-info"></i>
              </a>
              <a v-else href="javascript:;">
                <i class="icon ion-chatbox-working tx-20 tx-gray-600"></i>
              </a>
            </td>
            <td>
              <div>
                {{ $t("order.申请时间：") }}
                <span class="tx-white">{{ item.timeCreated }}</span>
              </div>
              <div>
                {{ $t("order.审核时间：") }}
                <span :class="{ 'tx-white': item.timeAudit }">
                  {{ item.timeAudit ? item.timeAudit : "----" }}
                </span>
              </div>
              <div>
                {{ $t("order.退货时间：") }}
                <span :class="{ 'tx-white': item.timeShipped }">
                  {{ item.timeShipped ? item.timeShipped : "----" }}
                </span>
              </div>
              <div>
                {{ $t("order.重发时间") }}：
                <span :class="{ 'tx-white': item.timeShippedBySp }">
                  {{ item.timeShippedBySp ? item.timeShippedBySp : "----" }}
                </span>
              </div>
              <div>
                {{ $t("order.完成时间：") }}
                <span :class="{ 'tx-white': item.timeShipped }">
                  {{ item.timeFinished ? item.timeFinished : "----" }}
                </span>
              </div>
            </td>
            <td>
              <div v-if="userInfo.productStyle == 2 && /1/.test(item.status)">
                <!-- <el-button v-if="new Date(item.timeCreated).getTime() + 2*24*60*60*1000 >= new Date()" size="mini" type="danger" >
                  {{$t("剩余审核时间")}}
                </el-button>
                <el-button size="mini" type="danger" v-else>
                  {{$t("超过审核时间")}}
                </el-button> -->
                <div class="tx-danger" v-if="new Date(item.timeCreated).getTime() + 2*24*60*60*1000 >= new Date()">
                   {{$t("剩余审核时间")}}
                </div>
                <div class="tx-danger" v-else>
                  {{$t("超过审核时间")}}
                </div>
                <div>
                  <span class="tx-danger">
                    {{ dateDiff(item.timeCreated).dd + $t('天') }}
                  </span>
                  <span class="tx-danger">
                    {{ dateDiff(item.timeCreated).hh + $t('小时') }}
                  </span>
                  <span class="tx-danger">
                    {{ dateDiff(item.timeCreated).mm + $t('分钟') }}
                  </span>
                </div>
              </div>
              <div
                v-if="
                  item.status == 1 && isSysRights('ReturnNote.auditBySupplier')
                "
              >
                <a
                  class="tx-info"
                  href="javascript:;"
                  @click="agreeReturn(item)"
                  >{{ $t("order.审核退货单") }}</a
                >
              </div>
              <div
                v-if="
                  item.status == 4 &&
                  item.type != 3 &&
                  isSysRights('ReturnNote.finishByUser')
                "
              >
                <a
                  class="tx-success"
                  href="javascript:;"
                  @click="completeReturn(item)"
                  >{{ $t("order.完成退货单") }}</a
                >
              </div>
              <div
                v-if="
                  item.status == 4 &&
                  item.type == 3 &&
                  isSysRights('ReturnNote.deliverBySupplier')
                "
              >
                <a
                  class="tx-info"
                  href="javascript:;"
                  @click="returnDeliver(item)"
                >
                  {{ $t("order.换货订单") }}
                </a>
              </div>
              <div v-if="isSysRights('ReturnNote.exportByUser')">
                <a
                  class="tx-info"
                  href="javascript:;"
                  @click="exportReturn(item.id)"
                  >{{ $t("order.导出商品清单") }}</a
                >
              </div>
              <!-- <div>
                <a
                  class="tx-info"
                  href="javascript:;"
                  @click="reviewReturnList(item)"
                  >{{ $t("order.审核退货清单") }}</a
                >
              </div> -->
            </td>
          </tr>
          <tr v-if="(!items || items.length < 1) && !first_loading">
            <td colspan="7">
              <div class="col-12 none-product">
                <i class="fa fa-ban"></i>{{ $t("order.没有符合条件的退货单") }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import {dateDiff} from '../../../utils/index'
export default {
  props: ["first_loading", "items", "returnStatus"],
  data() {
    return {
      returnType: arrDict.returnType,
      userInfo:store.get("userInfo"),
    };
  },
  filters: {
    statusClass(val) {
      let c = "";
      switch (val) {
        case "1":
        case "3":
          c = "tx-warning";
          break;
        case "2":
          c = "tx-danger";
          break;
        case "4":
        case "5":
          c = "tx-success";
          break;
        case "7":
          c = "tx-danger";
          break;
        default:
          break;
      }
      return c;
    },
  },
  methods: {
    dateDiff,
    //退货商品详情
    returnGoodsDetails(item) {
      this.$emit("returnGoodsDetails", item);
    },
    reviewReturnList(item){
      this.$emit('reviewReturnList',item)
    },
    showExpressLog(track) {
      //查看物流信息 有数据
      this.$emit("showExpressLog", track);
    },
    showExpress(item) {
      //查看物流信息
      this.$emit("showExpress", item);
    },
    agreeReturn(item) {
      this.$emit("agreeReturn", item);
    },
    completeReturn(item) {
      this.$emit("completeReturn", item);
    },
    exportReturn(id) {
      //导出
      this.$emit("exportReturn", id);
    },
    remarkFormat(r) {
      //备注格式化成html
      let html = "";
      r.forEach((e) => {
        html += `<p class="mg-b-5">${e}</p>`;
      });
      return html;
    },
    showAllProducts(item) {
      item.showAllProducts = true;
    },
    showStatu(val) {
      //显示订单状态
      let txt = "";
      this.returnStatus.forEach((e) => {
        if (e.val == val) txt = e.name;
      });
      return txt;
    },
    returnDeliver(item) {
      //发货
      this.$emit("returnDeliver", item);
    },
  },
  updated() {
    $('[data-toggle="popover"]').popover();
    $('[data-toggle="tooltip-primary"]').tooltip({
      template:
        '<div class="tooltip tooltip-primary" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
    });
  },
};
</script>
<style lang="less" scoped>
.data-table {
  tbody {
    font-size: 12px;
  }
}
.single {
    width: 140px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: break-all;  
}
.details {
  outline: none;
  ::v-deep span {
    color: #17a2b8 !important;
  }
}

</style>

